// Tipos/erro padronizado para identificar a etapa que falhou.
export type SubmitStage = 'UPLOAD' | 'FAT' | 'SEND';

export class SubmitError extends Error {
  constructor(
    public stage: SubmitStage,
    message: string,
    public original?: unknown
  ) {
    super(message);
    this.name = 'SubmitError';
  }
}

export function asSubmitError(err: unknown, fallbackStage: SubmitStage, fallbackMessage: string): SubmitError {
  if (err instanceof SubmitError) return err;
  const msg = (err as any)?.message ?? fallbackMessage;
  return new SubmitError(fallbackStage, msg, err);
}
